import { Theme } from '@mui/material/styles';
import HomePaperPad from '../../../PaperPad';
import BlockTitle from '../../components/BlockTitle';
import { KnownBreakpoints } from '../../../../common/constants';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Link from '@mui/material/Link';

const styles = {
    paper: (theme: Theme) => ({
        height: '480px',
        borderRadius: '20px',
        boxShadow: 1,
        p: 3,
        alignSelf: 'flex-start',
        position: 'sticky',
        top: '132px',
        display: 'flex',
        flexDirection: 'column',
        gap: '22px',
        alignItems: 'left',
        padding: '40px 30px 28px',
        [theme.breakpoints.down(KnownBreakpoints.tablet)]: {
            height: 'unset',
            position: 'unset',
        },
    }),
    link: (theme: Theme) => ({
        width: '100%',
        display: 'block',
        py: 1,
        px: 0,
        fontWeight: 500,
        cursor: 'pointer',
        color: theme.palette.text.primary,
        textDecorationColor: theme.palette.text.primary,
        '&:hover': {
            textDecoration: 'underline',
        },
    }),
};

interface TopicsSidebarProps {
    items: { label: string; anchor: string }[];
}

const TopicsSidebar: React.FunctionComponent<TopicsSidebarProps> = ({
    items,
}) => {
    return (
        <HomePaperPad sx={ styles.paper }>
            <BlockTitle title={ 'Topics' } />
            <List>
                {items.map((item) => (
                    <ListItem key={ item.anchor } disablePadding>
                        <Link
                            href={`#${ item.anchor }`}
                            underline='always'
                            sx={ styles.link }
                        >
                            { item.label }
                        </Link>
                    </ListItem>
                ))}
            </List>
        </HomePaperPad>
    );
};

export default TopicsSidebar;
